import "@babel/polyfill";
import * as query from './queries';
// import {uniqWith, chunk, isEmpty, differenceWith, includes, each} from "lodash";
import _ from "lodash";
import './animations/anims';

import '../../vendor/splide.min';
import '../../vendor/splide.min.css';
import '../color-switcher';
import '../scripts';
import '../sidebar';


//inners
import innerInsights from "./inner-page-templates/innerInsights";
import innerContacts from "./inner-page-templates/innerContacts";
import innerArticlePerson from "./inner-page-templates/innerArticlePerson";
import {fetchField, fetchPostField, fetchTranslatedField} from "./textChanger";


//templates
import careersTemplate from "./templates/careersTemplate";


//css
import '../../css/style.css';


//color checking result

const defaultValue = 'all';
const currentLanguage = document.querySelector('html').getAttribute('lang');

//wait for data to filter
const animateFilter = async function (selector, waitFor) {
    await Promise.race(waitFor).then(() => {
        selector.classList.remove('filtering-block');
        selector.innerHTML = '';
    });
}

//aos values
const delay500 = 500;
const aos_0 = 'data-aos-offset="150" data-aos="fade-right"';
const aos_500 = 'data-aos-offset="350" data-aos="fade-right"';
const default_delay = 300;
//

const fetchData = async function (url) {
    try {
        const result = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        if (!result.ok) throw new Error('Request failed. (result.ok)')

        return await result.json();
    } catch (err) {
        return Promise.reject(err);
    }
}

//mount carousel
const mountSplide = function (selector) {
    return new Splide(selector, {
        type: 'loop',
        perPage: 4,
        perMove: 1,
        speed: 600,
        easing: 'cubic-bezier(0.445, 0.05, 0.55, 0.95)',
        pagination: false,
        arrows: false,
        fixedWidth: '26.25vw',
        fixedHeight: '42vw',
        gap: 16,
        breakpoints: {
            769: {
                type: 'slide',
                drag: false,
                fixedWidth: '88.5%',
                fixedHeight: '150vw',

                autoHeight: true,
            },
        }
    });
}


//loading post types language check
const checkForLanguage = function (translationsArr, defaultLang) {
    let lang;
    const htmlLang = sel('html')?.getAttribute('lang');
    if (!_.isEmpty(translationsArr) && !_.includes(htmlLang, 'en')) {
        const url = translationsArr.filter(({
                                                href,
                                                locale
                                            }) => locale.includes(document.documentElement.getAttribute('lang').substring(0, 2)));

        if (url.length) {
            const {href} = url[0];
            lang = href;
        }
    } else lang = defaultLang;

    return lang;
}

//check if not en
const getPostTranslations = function (translationsArr, state = 'init') {
    const htmlLang = sel('html')?.getAttribute('lang');
    if (_.includes(htmlLang, 'en')) return;

    if (state === 'categorized') {
        return translationsArr.filter(({locale: {locale}}) => {
            return locale.includes(document.documentElement.getAttribute('lang').substring(0, 2));
        });
    }

    return translationsArr.filter(({locale: {locale}}) => {
        return locale.includes(document.documentElement.getAttribute('lang').substring(0, 2));
    });
}

const practiceAreas = async function () {
    const results = await query.getPracticeAreas();
    const {data: {experiencePracticeAreas: {nodes}}} = results;
    return nodes;
}

const deleteDups = function (cats, practices) {
    practices.forEach(({slug, name}) => {
        cats.forEach((term, i) => {
            if (term.toLowerCase().replaceAll(' ').replaceAll('') === name.toLowerCase().replaceAll(' ').replaceAll(''))
                cats.splice(i, 1)
        });
    });

    return cats;
}

//img cursor follow
const cursorFollowImg = function (section, singleItems, allImages) {
    // return;

    if (sel(`${section}`)) {
        const sectionSel = sel(`${section}`);
        const actionItems = selAll(`${singleItems}`);
        const allImgs = selAll(`${allImages}`);

        actionItems.forEach((val, i) => {
            let valImg = val.querySelector('.action-image');

            val.addEventListener('mousemove', e => {
                allImgs.forEach(val => val.classList.remove('hovered-img'));

                valImg.style.top = `calc(${e.clientY}px + 3px)`;
                valImg.style.left = `calc(${e.clientX}px + 3px)`;
                valImg.classList.add('hovered-img');
            });
        });

        if ('IntersectionObserver' in window) {
            const observerCallback = function ([entry]) {
                if (!entry.isIntersecting) {
                    allImgs.forEach(val => val.classList.remove('hovered-img'));
                }
            }

            const observeSection = new IntersectionObserver(observerCallback, {
                threshold: 0.2,
                root: null,
            });

            observeSection.observe(sectionSel);
        }

        const sectionBgOverlay = document.querySelector('.section-bg-overlay');

        sectionBgOverlay.addEventListener('mousemove', () => {
            allImgs.forEach(val => val.classList.remove('hovered-img'));
        });
    }
}

//insights post type
const postTypeInsights = async function (selectBlock) {
    if (sel(`${selectBlock}`)) {
        const block = sel(`${selectBlock}`);
        block.classList.add('filtering-block');

        let counter = 0, getTranslations = [], translatedPosts = [], hardCodedTerms = [];

        await animateFilter(block, ['']);

        const lt = ['lithuania', 'leedu', 'lietuva', 'lietuva-lv'];
        const lv = ['latvia', 'läti', 'latvija', 'lati'];
        const ee = ['estonia', 'igaunija', "eesti", 'estija'];
        const wsie = ['all', 'kõik', 'visi', "all-et", 'all-lt', 'all-lv'];

        let currInsights = phpInsights;

        if (localStorage.getItem('current-color').includes('estonia')) {
            currInsights = phpInsightsEstonia;
        } else if (localStorage.getItem('current-color').includes('latvia')) {
            currInsights = phpInsightsLatvia;
        } else if (localStorage.getItem('current-color').includes('lithuania')) {
            currInsights = phpInsightsLithuania;
        }

        let res = ['all', 'all-lt', 'all-et', 'all-lv'];
        const filteredInsights = currInsights.filter(insight => {
            if (localStorage.getItem('current-color').includes('estonia'))
                res = ee.filter(country => insight.countries.includes(country));

            if (localStorage.getItem('current-color').includes('latvia'))
                res = lv.filter(country => insight.countries.includes(country));

            if (localStorage.getItem('current-color').includes('lithuania'))
                res = lt.filter(country => insight.countries.includes(country));

            if (localStorage.getItem('current-color').includes('all'))
                res = wsie.filter(country => insight.countries.includes(country));

            return (insight.countries.includes(res.join('')));
        });

        _.forEach(filteredInsights, ({title, countries, insights, date, img, url}) => {
            let getCountry = [], getInsight = '';

            _.forEach(countries, country => {
                if (!country.includes('all')) {
                    getCountry.push(country);
                }
            });

            _.forEach(insights, ins => {
                let insight = ins.toLowerCase();
                if (!insight.includes('all') && !insight.includes('visi-lt') && !insight.includes('visi') && !insight.includes('all-lt') && !insight.includes('all-et') && !insight.includes('koik') && !insight.includes('kõik')) {
                    getInsight = insight;
                }
            });

            block.insertAdjacentHTML('beforeend', innerInsights(url, getInsight.charAt(0).toUpperCase() + getInsight.slice(1), title, date, img, getCountry));
        });

        if (!_.isEmpty(translatedPosts)) {
            translatedPosts.forEach(({
                                         date,
                                         postTypeInsights: {insightsPhoto},
                                         title,
                                         uri,
                                         translations,
                                         translated: nodes,
                                     }, i) => {
                const {sourceUrl} = insightsPhoto || '';
                const formatDate = new Intl.DateTimeFormat(document.documentElement.getAttribute('lang'), {
                    day: 'numeric', month: 'long', year: 'numeric',
                }).format(new Date(date));
                const taxonomy = hardCodedTerms?.filter(({name}) => name.toLowerCase() !== 'all').map(({name}) => name).join('');

                let taxRes = '';

                switch (true) {
                    case _.includes(currentLanguage, 'et') : {
                        switch (true) {
                            case taxonomy.toLowerCase().trim().includes('video'): {
                                taxRes = 'Video';
                                break;
                            }
                            case taxonomy.toLowerCase().trim().includes('blog'): {
                                taxRes = 'Blogi';
                                break;
                            }
                            case taxonomy.toLowerCase().trim().includes('cast'): {
                                taxRes = 'Podcastid';
                                break;
                            }
                            case taxonomy.toLowerCase().trim().includes('news'): {
                                taxRes = 'Uudised';
                                break;
                            }
                            case taxonomy.toLowerCase().trim().includes('events'): {
                                taxRes = 'Sündmused';
                                break;
                            }
                        }
                        break;
                    }
                    case _.includes(currentLanguage, 'lt') : {
                        switch (true) {
                            case taxonomy.toLowerCase().trim().includes('video'): {
                                taxRes = 'Vaizdo įrašai';
                                break;
                            }
                            case taxonomy.toLowerCase().trim().includes('blog'): {
                                taxRes = 'Tinklaraštis';
                                break;
                            }
                            case taxonomy.toLowerCase().trim().includes('cast'): {
                                taxRes = 'Tinklalaidės';
                                break;
                            }
                            case taxonomy.toLowerCase().trim().includes('news'): {
                                taxRes = 'Naujienos';
                                break;
                            }
                            case taxonomy.toLowerCase().trim().includes('events'): {
                                taxRes = 'Renginiai';
                                break;
                            }
                        }
                        break;
                    }
                    case _.includes(currentLanguage, 'lv') : {
                        switch (true) {
                            case taxonomy.toLowerCase().trim().includes('video'): {
                                taxRes = 'Video';
                                break;
                            }
                            case taxonomy.toLowerCase().trim().includes('blog'): {
                                taxRes = 'Blogs';
                                break;
                            }
                            case taxonomy.toLowerCase().trim().includes('cast'): {
                                taxRes = 'Podcastid';
                                break;
                            }
                            case taxonomy.toLowerCase().trim().includes('news'): {
                                taxRes = 'Jaunumi';
                                break;
                            }
                            case taxonomy.toLowerCase().trim().includes('events'): {
                                taxRes = 'Pasākumi';
                                break;
                            }
                        }
                        break;
                    }
                }

                counter++;
                block.insertAdjacentHTML('beforeend', innerInsights(checkForLanguage(translations, uri), taxRes, title, formatDate, sourceUrl, counter));

            });
        }

        const actions = document.querySelectorAll('.future-radar-section .actions .single-action');
        let mod = 3;
        let acts = [...actions].reverse();

        for (let i = 0; i < mod; i++)
            if (acts.at(i))
                acts.at(i).classList.add('bottom-border-item');

        cursorFollowImg('.future-radar-section', '.future-radar-section .single-action', '.future-radar-section .action-image');

        if (screenWidth.matches) {
            actions.forEach((val, i) => {
                if (i > 2) val.style.display = 'none';
            });
        }
    }
}

//post careers
const postTypeCareers = async function (selectBlock, returnPractices = false) {
    if (sel(`${selectBlock}`)) {
        const block = sel(`${selectBlock}`);
        block.classList.add('filtering-block');

        const results = await query.getNewCareers(localStorage.getItem('current-color') || defaultValue);
        const {data: {careers: {nodes}}} = results;
        let getTranslations = [], translatedPosts = [];
        const shownUris = new Set(); // Track already shown posts to prevent duplicates

        // Get the parent section and its table/empty elements
        const parentSection = block.closest('.offers-section') || block.closest('section');
        const table = parentSection ? parentSection.querySelector('.offers-table') : sel('.offers-table');
        const empty = parentSection ? parentSection.querySelector('.empty-offers') : sel('.empty-offers');

        // For practices section, also get the section element itself to control visibility
        const practicesSection = returnPractices ? sel('#practices') : null;

        // IMPORTANT: careers page office filter should follow the UI buttons, not global "current-color".
        // "current-color" is used for theme/location switching and can be "lithuania" even when "All" is active.
        const getActiveOfficeFilter = () => {
            const scope = parentSection || document;
            const activeBtn = scope.querySelector('.people-main-section.filter-heading .main-offices .single-office.active');
            if (!activeBtn) return 'all';
            if (activeBtn.classList.contains('estonia')) return 'estonia';
            if (activeBtn.classList.contains('latvia')) return 'latvia';
            if (activeBtn.classList.contains('lithuania')) return 'lithuania';
            return 'all';
        };

        const lt = ['lithuania', 'leedu', 'lietuva', 'vilnius'];
        const lv = ['latvia', 'läti', 'latvija', 'riga'];
        const ee = ['estonia', 'igaunija', 'eesti', 'estija', 'talinn'];
        const wsie = ['all', 'kõik', 'visi'];

        const normalizeUri = (maybeUrl) => {
            if (!maybeUrl || typeof maybeUrl !== 'string') return '';
            // Convert absolute URL to path so we don't treat them as different entries.
            // (translations.href often returns absolute URL while uri is relative)
            if (/^https?:\/\//i.test(maybeUrl)) {
                try {
                    const u = new URL(maybeUrl);
                    return `${u.pathname}${u.search || ''}${u.hash || ''}`;
                } catch (e) {
                    return maybeUrl;
                }
            }
            return maybeUrl;
        };

        // Helper function to add post and track URI
        const addCareerPost = (postUri, postTitle, office, practice) => {
            const normalized = normalizeUri(postUri);
            // Skip if URI is missing, undefined, or the string "undefined"
            if (!normalized || normalized === 'undefined' || shownUris.has(normalized)) {
                return;
            }
            shownUris.add(normalized);
            block.insertAdjacentHTML('beforeend', careersTemplate(normalized, postTitle, office ? office : '', practice ? practice : ''));
        };

        const getUriForCurrentLanguage = (fallbackUri, translations = []) => {
            const currentLangCode = (currentLanguage || '').substring(0, 2).toLowerCase();
            if (Array.isArray(translations) && translations.length) {
                const match = translations.find(t => (t?.locale || '').substring(0, 2).toLowerCase() === currentLangCode);
                if (match?.href) return {uri: normalizeUri(match.href), hasMatch: true};
            }
            return {uri: normalizeUri(fallbackUri), hasMatch: false};
        };

        //
        await animateFilter(block, nodes);
        if (!_.isEmpty(nodes)) {
            nodes.forEach(({
                               status,
                               postTypeCareer: {
                                   careersHidden,
                                   careersOffice,
                                   careersPractice,
                                   studentPractice = false
                               },
                               locale: {
                                   locale
                               },
                               title,
                               uri,
                               translations,
                               translated
                           }) => {
                const isPublished = String(status || '').toLowerCase() === 'publish';
                if (!isPublished) return;
                // Guard against "ghost" nodes coming from GraphQL cache/bad translations
                if (!title || typeof title !== 'string' || !title.trim()) return;
                if (!uri || typeof uri !== 'string') return;
                if (!careersHidden) {
                    if (returnPractices && !studentPractice) return
                    if (!returnPractices && studentPractice) return

                    // NOTE: do not call getPostTranslations() for careers.
                    // WPGraphQL may return translated nodes with locale: null (or translated: []),
                    // and getPostTranslations() destructures locale.locale which would throw and stop rendering.

                    // Only show posts whose locale matches current site language.
                    // GraphQL returns one node per language, so the LT version is already in `nodes`
                    // as its own entry; rendering EN posts via translation links would duplicate it
                    // under a different URL (e.g. /lt/?p=32147 vs /lt/karjera/<slug>/).
                    const currentLangCode = currentLanguage.substring(0, 2).toLowerCase();
                    const postLangCode = (locale || '').substring(0, 2).toLowerCase();
                    if (currentLangCode !== postLangCode) return;

                    const officeFilter = getActiveOfficeFilter();
                    const officeKeywords =
                        officeFilter === 'lithuania' ? lt :
                        officeFilter === 'latvia' ? lv :
                        officeFilter === 'estonia' ? ee : null;

                    if (officeKeywords) {
                        const officeStr = (careersOffice || '').toLowerCase();
                        const matches = officeKeywords.some(keyword => officeStr.includes(keyword));
                        if (!matches) return;
                    }

                    addCareerPost(uri, title, careersOffice, careersPractice);
                }
            });
        } else {
            table.style.display = 'none';
            empty.classList.add('active');
        }

        if (!block.innerHTML) {
            table.style.display = 'none';
            empty.classList.add('active');
            // Hide practices section if no practices posts
            if (practicesSection) {
                practicesSection.style.display = 'none';
            }
        } else {
            table.style.display = 'block';
            empty.classList.remove('active');
            // Show practices section if there are practices posts
            if (practicesSection) {
                practicesSection.style.display = 'block';
            }
        }
    }
}

//post type contacts;
const postTypeContacts = async function (selectBlock, photos, singleOffices, stickyPhotosSel) {
    if (sel(`${selectBlock}`)) {
        const block = sel(`${selectBlock}`);
        block.classList.add('filtering-block');

        const results = await query.getContacts(localStorage.getItem('current-color') || defaultValue);
        const {data: {countries: {nodes}}} = results;
        let getTranslations = [], translatedPosts = [];

        await animateFilter(block, nodes);
        nodes.forEach(({contacts: {nodes}}) => {
            try {
                nodes.forEach(({
                                   title,
                                   postTypeContacts: {
                                       contactAddress,
                                       contactEamils,
                                       contactLinkedin,
                                       contactMap: {target, title: btnTitle, url},
                                       contactFind,
                                       contactPhones,
                                   },
                                   translated
                               }) => {

                    getTranslations = getPostTranslations(translated);

                    if (currentLanguage.includes('en'))
                        if (contactFind) {
                            const {target: target2, title: btnTitle2, url: url2} = contactFind;

                            block.insertAdjacentHTML('beforeend', innerContacts(title, contactLinkedin, contactAddress, url, target, btnTitle, url2, target2, btnTitle2, contactPhones[0].phone, contactEamils[0].email));
                        } else {
                            block.insertAdjacentHTML('beforeend', innerContacts(title, contactLinkedin, contactAddress, url, target, btnTitle, '', '', '', contactPhones[0].phone, contactEamils[0].email));

                        }
                    else translatedPosts.push(...getTranslations);
                });
            } catch (e) {

            }

        });

        if (!_.isEmpty(translatedPosts)) {
            translatedPosts.forEach(({
                                         postTypeContacts: {
                                             contactAddress,
                                             contactEamils,
                                             contactLinkedin,
                                             contactMap: {target, title: btnTitle, url},
                                             contactFind,
                                             contactPhones,
                                         },
                                         title
                                     }) => {

                if (contactFind) {
                    const {target: target2, title: btnTitle2, url: url2} = contactFind;

                    block.insertAdjacentHTML('beforeend', innerContacts(title, contactLinkedin, contactAddress, url, target, btnTitle, url2, target2, btnTitle2, contactPhones[0].phone, contactEamils[0].email));
                } else {
                    block.insertAdjacentHTML('beforeend', innerContacts(title, contactLinkedin, contactAddress, url, target, btnTitle, '', '', '', contactPhones[0].phone, contactEamils[0].email));

                }
            });
        }

        // AOS.init({
        //     disable: false,
        //     startEvent: 'DOMContentLoaded',
        //     initClassName: 'aos-init',
        //     animatedClassName: 'aos-animate',
        //     useClassNames: false,
        //     disableMutationObserver: false,
        //     debounceDelay: 50,
        //     throttleDelay: 99,
        //     offset: 30,
        //     delay: 0,
        //     duration: 1600,
        //     easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
        //     once: true,
        //     mirror: false,
        //     anchorPlacement: 'top-top',
        // });

        const stickyPhotos = sel(`${stickyPhotosSel}`)
        let arr = [];

        nodes.forEach(({contacts: {nodes}}) => {
            nodes.forEach(({postTypeContacts: {contactPhoto: {sourceUrl}}}, i) => {
                const singlePhoto = `
                <div class="photo ${i === 0 && 'active'}"
                    style="background: url(${sourceUrl}) center / cover no-repeat;">
                </div>`;

                arr.push(singlePhoto);
                stickyPhotos.insertAdjacentHTML('beforeend', singlePhoto);
            });
        });

        setTimeout(() => {
            const singleOffices = selAll('.our-offices-section .single-office .left-side-inner');

            singleOffices.forEach((val, i) => {
                val.insertAdjacentHTML('afterbegin', arr[i]);
            });
        });

        const photo = selAll(`${photos}`);
        const singleOffice = selAll(`${singleOffices}`);

        let crossed = [];

        function officeCheck(passArr) {
            passArr.forEach((val, i) => {
                if (val.getBoundingClientRect().top - document.documentElement.clientHeight / 2 < 0) {
                    crossed.push(val);
                    crossed.forEach(val => {
                        let blur = val.querySelector('.blured');
                        blur.classList.remove('active');
                    });

                    photo.forEach(ph => ph.classList.remove('active'));
                    photo[i].classList.add('active');

                    crossed.at(-1).querySelector('.blured').classList.add('active');
                }
            });
        }

        if (!screenWidth.matches) {
            officeCheck(singleOffice)
            window.addEventListener('scroll', () => officeCheck(singleOffice));
        }
    }
}

const getPeople = async function () {

    return;
    const titles = selAll('.page-template-page-services .table-body .position');

    const arr = [...titles].map(title => query.getPeopleCount(title.textContent));
    const chunks = _.chunk(arr, 3);

    const countries = selAll('.sf-field-taxonomy-person_countries > ul > li');
    let selectedCountry, country = '';

    countries.forEach((country, i) => {
        if (country.classList.contains('sf-option-active')) {
            selectedCountry = i;
        }
    });

    if (selectedCountry === 1) {
        country = 'estonia';
    } else if (selectedCountry === 2) {
        country = 'latvia';
    } else if (selectedCountry === 3) {
        country = 'lithuania';
    }

    chunks.forEach(val => {
        Promise.all(val).then(value => {
            let length;
            let ti;

            value.forEach((resp, i) => {
                const {data: {services: {nodes}}} = resp;
                let count = 0;

                nodes.forEach(({title, postTypeService: {servicesRelatedPeople}}) => {
                    ti = title;

                    if (window.location.href.includes('_sft_person_countries')) {
                        servicesRelatedPeople.forEach(({countries: {nodes}}) => {
                            nodes.forEach(({slug}) => {
                                if (!_.includes(slug?.toLowerCase().trim(), 'all')) {
                                    if (_.includes(slug?.toLowerCase().trim(), country)) {
                                        count++;
                                    }
                                }
                            });
                        });

                        length = count;
                        return;
                    }

                    length = servicesRelatedPeople?.length || 0;
                });

                ;const el = Array.from(titles).find(el => el.querySelector('h4').textContent === ti);

                if (length !== 0) {
                    el.nextElementSibling.nextElementSibling.classList.add('active');
                }

                if (el) {
                    if (el.nextElementSibling) {
                        if (el.nextElementSibling.nextElementSibling) {
                            if (el.nextElementSibling.nextElementSibling.querySelector('.number')) {
                                el.nextElementSibling.nextElementSibling.querySelector('.number').textContent = length;
                            }
                        }
                    }
                }
            });
        });
    });
}

const filterPress = function (state = 'load', arr = []) {
    if (!sel('.sf-field-taxonomy-person_countries > ul > li > label')) return;
    const countries = selAll('.sf-field-taxonomy-person_countries > ul > li > label');
    const offices = selAll('.people-main-section.filter-heading.sh .main-offices .single-office');

    if (state === 'load') {
        if (!localStorage.getItem('current-color')) return;

        offices.forEach((office, i) => {
            if (office.classList.contains(localStorage.getItem('current-color')))
                countries[i].click();
        });

        countries.forEach(country => {
            if (country.textContent.toLowerCase().includes(localStorage.getItem('current-color')))
                country.click();
        });
    }

    if (state === 'filter') {
        setTimeout(() => {
            const getActive = [...arr].filter(val => val.parentElement.classList.contains('active-item'));
            const destCountry = [...countries].find(val => val.textContent.toLowerCase().includes(getActive.at(0).textContent.toLowerCase()));
            destCountry.click();
        });
    }
}

const filterByCountry = function (arr) {
    const country = localStorage.getItem('current-color') || defaultValue;
    const filterByCountry = arr.flat(1).filter(val => {
        const {terms: {nodes}} = val;
        const some = nodes.some(({name, slug}) => slug === country);
        return some;
    });

    return filterByCountry;
}

//inner article people
const getInnerArticlePeople = async function (selectBlock) {
    if (!sel(`${selectBlock}`)) return;
    const block = sel(`${selectBlock}`);
    block.classList.add('filtering-block');
    const results = await query.getInnerArticlePeople();
    const practiceArea = await practiceAreas();
    const currentTitle = sel('.current-article-title').getAttribute('data-article');
    const {data: {persons: {nodes}}} = results;

    await animateFilter(block, nodes);
    if (!localStorage.getItem('current-color')) {
        //filter by title
        const currentArticleRelated = nodes.filter(val => {
            const {postTypePersons: {personInnerArticle}} = val;
            if (!personInnerArticle) return;

            let valueReturn, res;
            personInnerArticle.forEach(({id, title}) => {
                if (title.toLowerCase().replaceAll(' ', '').trim() === currentTitle.toLowerCase().replaceAll(' ', '').trim())
                    valueReturn = val;
            });

            return valueReturn;
        });

        currentArticleRelated.forEach(val => {
            const {
                postTypePersons: {personsButtonText, personsLinkedin, personsPhoto},
                terms: {nodes},
                title,
                translations,
                uri
            } = val;

            const {sourceUrl} = personsPhoto || '';

            const categories = nodes.map(({name}) => {
                if (name?.toLowerCase() !== 'all')
                    return name;
            }).filter(val => val && val);

            block.insertAdjacentHTML('beforeend', innerArticlePerson(checkForLanguage(translations, uri), sourceUrl, title, deleteDups(categories, practiceArea), personsButtonText, personsLinkedin));
        });
        return;
    } else {
        //filter by title and country
        const currentArticleRelated = nodes.filter(val => {
            const {postTypePersons: {personInnerArticle}} = val;
            if (!personInnerArticle) return;

            let valueReturn, res;
            personInnerArticle.forEach(({id, title}) => {
                if (title.toLowerCase().replaceAll(' ', '').trim() === currentTitle.toLowerCase().replaceAll(' ', '').trim())
                    valueReturn = val;
            });

            return valueReturn;
        });

        if (!localStorage.getItem('current-color').includes('all')) {
            const filterByCountry = currentArticleRelated.filter(val => {
                const {postTypePersons, terms: {nodes}} = val;
                let res;

                nodes.forEach(term => {
                    const {name, slug} = term;

                    if (slug?.toLowerCase().trim() !== 'all' && slug?.toLowerCase().trim().includes(localStorage.getItem('current-color'))) {
                        res = term;
                    }
                });

                return res;
            });

            filterByCountry.forEach(val => {
                const {
                    postTypePersons: {personsButtonText, personsLinkedin, personsPhoto},
                    terms: {nodes},
                    title,
                    translations,
                    uri
                } = val;

                const {sourceUrl} = personsPhoto || '';

                const categories = nodes.map(({name}) => {
                    if (name?.toLowerCase() !== 'all')
                        return name;
                }).filter(val => val && val);

                block.insertAdjacentHTML('beforeend', innerArticlePerson(checkForLanguage(translations, uri), sourceUrl, title, deleteDups(categories, practiceArea), personsButtonText, personsLinkedin));
            });

            return;
        }

        currentArticleRelated.forEach(val => {
            const {
                postTypePersons: {personsButtonText, personsLinkedin, personsPhoto},
                terms: {nodes},
                title,
                translations,
                uri
            } = val;

            const {sourceUrl} = personsPhoto || '';

            const categories = nodes.map(({name}) => {
                if (name?.toLowerCase() !== 'all')
                    return name;
            }).filter(val => val && val);

            block.insertAdjacentHTML('beforeend', innerArticlePerson(checkForLanguage(translations, uri), sourceUrl, title, deleteDups(categories, practiceArea), personsButtonText, personsLinkedin));
        });
    }
}

// Table expansion functionality for single-table-person
jQuery(document).ready(function ($) {
    if (document.querySelector('.single-not-expanded')) {
        const arrowMore = document.querySelectorAll('.arrow-more svg');

        $('body').on('click', '.single-not-expanded', function (e) {
            // Close all other expanded rows
            $('.table-content').find('.single-expanded').stop().slideUp();

            // Toggle the clicked row
            $(this).closest('.single-table-person').find('.single-expanded').stop().slideToggle();

            // Handle active state
            if (!this.closest('.single-not-expanded').classList.contains('active')) {
                this.closest('.single-not-expanded').classList.add('active');
            }

            // Handle arrow rotation
            if (this.querySelector('.arrow-more svg').classList.contains('active')) {
                arrowMore.forEach(arrow => {
                    arrow.classList.remove('active');
                    arrow.parentElement.parentElement.classList.remove('active');
                });
            } else {
                arrowMore.forEach(arrow => {
                    arrow.classList.remove('active');
                    arrow.parentElement.parentElement.classList.remove('active');
                });
                this.querySelector('.arrow-more').classList.add('active');
                this.querySelector('.arrow-more svg').classList.add('active');
            }
        });
    }
});

window.addEventListener('load', () => {
    filterPress('load');
    getPeople();

    if (sel('.people-main-section .locations .main-offices')) {
        jQuery(document).ready(function ($) {
            $(document).ajaxComplete(function () {
                getPeople();
            });
        });
    }

    //insights article people
    if (sel('.single-insights .people-main-section .locations .main-offices')) {
        getInnerArticlePeople('#article-person-filter', `.current-article-title`);

        const btns = selAll(`.single-insights .people-main-section.filter-heading .single-office`);
        btns?.forEach((btn, i) => btn.addEventListener('click', () => {
            getInnerArticlePeople('#article-person-filter', `.current-article-title`);
        }));
    }

    //posts contacts
    if (sel(`.page-contacts .filter-heading .single-office`)) {
        postTypeContacts('.page-contacts .our-offices-section .offices-left', `.our-offices-section .right-photos-sticky .photo`, `.our-offices-section .single-office`, `.right-photos-sticky`);

        const btns = selAll(`.page-contacts .filter-heading .single-office`);
        btns?.forEach(btn => btn.addEventListener('click', () => {
            postTypeContacts('.page-contacts .our-offices-section .offices-left', `.our-offices-section .right-photos-sticky .photo`, `.our-offices-section .single-office`, `.right-photos-sticky`);
        }));
    }

    //posts career
    if (sel(`.people-main-section.filter-heading .single-office`)) {
        postTypeCareers('#career-filter', false);
        postTypeCareers('#practices-filter', true);

        const btns = selAll(`.people-main-section.filter-heading .single-office`);
        btns.forEach(btn => btn.addEventListener('click', () => {
            postTypeCareers('#career-filter', false);
            postTypeCareers('#practices-filter', true);
        }));
    }


    const BIG_PATCH = function () {
        if (sel('.page-home')) {
            //videos

            const videoInsert = function (country) {
                if (sel(`.video-country.${country} video`)) return;
                if (screenWidth.matches) return;

                const videoCountry = sel(`.video-country.${country}`)
                const video = document.createElement('video');
                const h265 = document.createElement('source');
                const h264 = document.createElement('source');

                switch (country) {
                    case 'all': {
                        h265.src = window.innerWidth > 1500 ? 'https://triniti.eu/wp-content/uploads/2024/04/brown-h265.mp4' : 'https://triniti.eu/wp-content/uploads/2024/04/brown-h265-1500.mp4';
                        h265.type = 'video/mp4';
                        h265.codecs = 'hevc';
                        video.appendChild(h265);

                        h264.src = window.innerWidth > 1500 ? 'https://triniti.eu/wp-content/uploads/2024/04/brown-h264.mp4' : 'https://triniti.eu/wp-content/uploads/2024/04/brown-h264-1500.mp4';
                        h264.type = 'video/mp4';
                        video.appendChild(h264);
                        break;
                    }

                    case 'estonia': {
                        h265.src = window.innerWidth > 1500 ? 'https://triniti.eu/wp-content/uploads/2024/04/blue-h265.mp4' : 'https://triniti.eu/wp-content/uploads/2024/04/blue-h265-1500.mp4';
                        h265.type = 'video/mp4';
                        h265.codecs = 'hevc';
                        video.appendChild(h265);

                        h264.src = window.innerWidth > 1500 ? 'https://triniti.eu/wp-content/uploads/2024/04/blue-h264.mp4' : 'https://triniti.eu/wp-content/uploads/2024/04/blue-h264-1500.mp4';
                        h264.type = 'video/mp4';
                        video.appendChild(h264);
                        break;
                    }

                    case 'latvia': {
                        h265.src = window.innerWidth > 1500 ? 'https://triniti.eu/wp-content/uploads/2024/04/violet-h265.mp4' : 'https://triniti.eu/wp-content/uploads/2024/04/violet-h265-1500.mp4';
                        h265.type = 'video/mp4';
                        h265.codecs = 'hevc';
                        video.appendChild(h265);

                        h264.src = window.innerWidth > 1500 ? 'https://triniti.eu/wp-content/uploads/2024/04/violet-h264.mp4' : 'https://triniti.eu/wp-content/uploads/2024/04/violet-h264-1500.mp4';
                        h264.type = 'video/mp4';
                        video.appendChild(h264);
                        break;
                    }

                    case 'lithuania': {
                        h265.src = window.innerWidth > 1500 ? 'https://triniti.eu/wp-content/uploads/2024/04/green-h265.mp4' : 'https://triniti.eu/wp-content/uploads/2024/04/green-h265-1500.mp4';
                        h265.type = 'video/mp4';
                        h265.codecs = 'hevc';
                        video.appendChild(h265);

                        h264.src = window.innerWidth > 1500 ? 'https://triniti.eu/wp-content/uploads/2024/04/green-h264.mp4' : 'https://triniti.eu/wp-content/uploads/2024/04/green-h264-1500.mp4';
                        h264.type = 'video/mp4';
                        video.appendChild(h264);
                        break;
                    }

                    default: {
                        h265.src = window.innerWidth > 1500 ? 'https://triniti.eu/wp-content/uploads/2024/04/brown-h265.mp4' : 'https://triniti.eu/wp-content/uploads/2024/04/brown-h265-1500.mp4';
                        h265.type = 'video/mp4';
                        h265.codecs = 'hevc';
                        video.appendChild(h265);

                        h264.src = window.innerWidth > 1500 ? 'https://triniti.eu/wp-content/uploads/2024/04/brown-h264.mp4' : 'https://triniti.eu/wp-content/uploads/2024/04/brown-h264-1500.mp4';
                        h264.type = 'video/mp4';
                        video.appendChild(h264);
                        break;
                    }
                }

                video.autoplay = true;
                video.muted = true;
                video.playsInline = true;
                video.loop = true;

                videoCountry.insertAdjacentElement('beforeend', video);
            }

            videoInsert(localStorage.getItem('current-color'));

            const lang = sel('html').getAttribute('lang');
            const words = ['en-US', 'et', 'lv-LV', 'lt-LT'];
            const currentLocation = window.location.href;
            const newExperiences = sel('.splide-experience .splide__list');


            if (new RegExp(words.join('|')).test(lang)) {
                //get posts
                (async () => {
                    let id;
                    switch (localStorage.getItem('current-color')) {
                        case 'all': {
                            switch (lang) {
                                case 'en-US': {
                                    id = 112;
                                    break;
                                }

                                case 'et': {
                                    id = 663;
                                    break;
                                }

                                case 'lv-LV': {
                                    id = 306;
                                    break;
                                }

                                case 'lt-LT': {
                                    id = 644;
                                    break;
                                }
                            }
                            break;
                        }

                        case 'estonia': {
                            switch (lang) {
                                case 'en-US': {
                                    id = 70;
                                    break;
                                }

                                case 'et': {
                                    id = 296;
                                    break;
                                }

                                case 'lv-LV': {
                                    id = 754;
                                    break;
                                }

                                case 'lt-LT': {
                                    id = 260;
                                    break;
                                }
                            }
                            break;
                        }

                        case 'latvia': {
                            switch (lang) {
                                case 'en-US': {
                                    id = 69;
                                    break;
                                }

                                case 'et': {
                                    id = 294;
                                    break;
                                }

                                case 'lv-LV': {
                                    id = 400;
                                    break;
                                }

                                case 'lt-LT': {
                                    id = 406;
                                    break;
                                }
                            }

                            break;
                        }

                        case 'lithuania': {
                            switch (lang) {
                                case 'en-US': {
                                    id = 71;
                                    break;
                                }

                                case 'et': {
                                    id = 252;
                                    break;
                                }

                                case 'lv-LV': {
                                    id = 252;
                                    break;
                                }

                                case 'lt-LT': {
                                    id = 248;
                                    break;
                                }
                            }

                            break;
                        }
                    }

                    const url = `${currentLocation}/wp-json/wp/v2/experience/?acf_format=standard&_embed=1&person_countries=${id}&per_page=6`;

                    let splide = new Splide('.splide-experience', {
                        type: 'slide',
                        perPage: 4,
                        perMove: 1,
                        speed: 600,
                        easing: 'cubic-bezier(0.445, 0.05, 0.55, 0.95)',
                        pagination: false,
                        arrows: false,
                        fixedWidth: '26.25vw',
                        fixedHeight: '42vw',
                        gap: 16,
                        breakpoints: {
                            769: {
                                type: 'slide',
                                drag: false,
                                fixedWidth: '88.5%',
                                fixedHeight: '150vw',

                                autoHeight: true,
                            },
                        }
                    });

                    newExperiences.innerHTML = '';

                    setTimeout(() => {
                        (async () => {
                            const data = await fetchData(url);
                            for (let i = 0; i < data.length; i++) {
                                const a = document.createElement('a');
                                a.classList.add('splide__slide');
                                a.href = data[i]['link'];

                                const photo = document.createElement('div');
                                photo.classList.add('photo');

                                if (data[i]['acf']['experience_photo']) {
                                    photo.style.background = `url(${data[i]['acf']['experience_photo']}) center / cover no-repeat`
                                } else {
                                    photo.style.background = `url(https://triniti.eu/wp-content/uploads/2021/12/Corporate-Commercial-MA01.jpg) center / cover no-repeat`
                                }

                                const caption = document.createElement('div');
                                caption.classList.add('slide-caption');

                                const text = document.createElement('h4');
                                text.classList.add('text');
                                text.innerHTML = data[i]['title']['rendered'];

                                const infos = document.createElement('div');
                                infos.classList.add('infos');


                                const slugs = _.map(data[i]['_embedded']['wp:term'].flat(1), 'name');

                                _.each(slugs, slug => {
                                    if (_.includes(slug.toLowerCase(), 'all')) return;
                                    const html = `
                                 <div class="btn-stroke mini-pclassNameg">
                                    <span>${slug}</span>
                                 </div>
                                `;

                                    infos.insertAdjacentHTML('beforeend', html);
                                })

                                caption.insertAdjacentElement('beforeend', text);
                                caption.insertAdjacentElement('beforeend', infos);

                                a.insertAdjacentElement('beforeend', photo);
                                a.insertAdjacentElement('beforeend', caption);
                                newExperiences.insertAdjacentElement('beforeend', a);
                            }
                            splide.mount();

                            setTimeout(() => {
                                splide.destroy();
                                splide.mount();
                            }, 1000)
                        })();
                    }, screenWidth.matches ? 5000 : 0);
                })();
            } else {
                //get page fields
                (async () => {
                    // const url = `${currentLocation}/wp-json/wp/v2/pages/?slug=homepage`;
                    // const data = await fetchData(url);
                    //
                    // console.log(data);
                })();
            }
        }
    }


    //posts experience
    if (sel('.recent-experience-section.filter-heading-inner')) {
        if (currentLanguage.includes('de') && sel('.recent-experience-section.filter-heading-inner .single-office') || sel('.recent-experience-section.filter-heading-inner .single-office') && currentLanguage.includes('sv') || sel('.recent-experience-section.filter-heading-inner .single-office') && currentLanguage.includes('pl') || sel('.recent-experience-section.filter-heading-inner .single-office') && currentLanguage.includes('ru')) {
            const experienceBlock = sel('.recent-experience-section');
            const officeLocations = selAll('.recent-experience-section .office-locations .main-offices .single-office');
            const splideSlides = selAll('.recent-experience-section .splide-experience .splide__slide');
            const splideList = sel('.recent-experience-section .splide-experience .splide__list');

            const allowed = splideSlides.length > 3;

            if (_.isEmpty(splideSlides)) {
                experienceBlock.style.display = 'none';
            }

            const splide = new Splide('.recent-experience-section .splide-experience', {
                type: 'slide',
                perPage: 4,
                perMove: 1,
                speed: 600,
                easing: 'cubic-bezier(0.445, 0.05, 0.55, 0.95)',
                pagination: false,
                arrows: false,
                fixedWidth: '26.25vw',
                fixedHeight: '42vw',
                drag: allowed,
                gap: 16,
                breakpoints: {
                    769: {
                        type: 'slide',
                        drag: false,
                        fixedWidth: '88.5%',
                        fixedHeight: '150vw',

                        autoHeight: true,
                    },
                }
            });

            let slides = [...splideSlides], attrs = _.map(splideSlides, el => el.getAttribute('data-office'));

            attrs = attrs.map(el => {
                if (!el) return '';
                const els = el.split('|');

                return els.map(val => {
                    if (val.toLowerCase().includes('igaunija') || val.toLowerCase().includes('eesti') || val.toLowerCase().includes('estija') || val.toLowerCase().includes('estonia')) {
                        return 'estonia';
                    } else if (val.toLowerCase().includes('lietuva') || val.toLowerCase().includes('leedu') || val.toLowerCase().includes('lietuva') || val.toLowerCase().includes('lithuania')) {
                        return 'lithuania';
                    } else if (val.toLowerCase().includes('läti') || val.toLowerCase().includes('latvija') || val.toLowerCase().includes('latvia')) {
                        return 'latvia';
                    } else {
                        return '';
                    }
                }).join('|');
            }).flat();

            _.each(officeLocations, val => {
                val.addEventListener('click', () => {
                    splideList.classList.add('filtering-block');

                    setTimeout(() => {
                        splide.destroy();
                        splideList.innerHTML = '';
                        const classes = val.getAttribute('class').split(' ');

                        _.each(attrs, (val, i) => {
                            const splited = val.split('|');
                            splited.forEach(val => {
                                if (val.includes(classes[1])) {
                                    splideList.insertAdjacentElement('beforeend', slides[i]);
                                }
                            });
                        });


                        if (!splideList.innerHTML) {
                            _.each(splideSlides, val => {
                                splideList.insertAdjacentElement('beforeend', val);
                            });
                        }

                        splideList.classList.remove('filtering-block');
                        splide.mount();

                        if (screenWidth.matches) {
                            slides.forEach((val, i) => {
                                if (i > 2) val.style.display = 'none';
                            });
                        }

                    }, 1000);
                });
            });

            splide.mount();

            const currColor = localStorage.getItem('current-color');

            if (currColor.includes('estonia')) {
                officeLocations[0].click();
            }

            if (currColor.includes('latvia')) {
                officeLocations[1].click();
            }

            if (currColor.includes('lithuania')) {
                officeLocations[2].click();
            }

            BIG_PATCH();

        } else if (sel('.recent-experience-section.filter-heading-inner .single-office') && currentLanguage.includes('en') || sel('.recent-experience-section.filter-heading-inner .single-office') && currentLanguage.includes('et') || sel('.recent-experience-section.filter-heading-inner .single-office') && currentLanguage.includes('lv') || sel('.recent-experience-section.filter-heading-inner .single-office') && currentLanguage.includes('lt')) {
            setTimeout(() => {
                const currColor = localStorage.getItem('current-color');
                const officeLocations = selAll('.recent-experience-section .office-locations .main-offices .single-office');

                if (currColor.includes('estonia')) {
                    officeLocations[0].click();
                }

                if (currColor.includes('latvia')) {
                    officeLocations[1].click();
                }

                if (currColor.includes('lithuania')) {
                    officeLocations[2].click();
                }

            }, 1000)
            BIG_PATCH();
        }
    }

    //insights
    if (sel('.page-home .future-radar-section .single-office')) {
        postTypeInsights('.page-home .future-radar-section .actions');
        const btnsIns = selAll('.page-home .future-radar-section .single-office');

        btnsIns.forEach(btn => btn.addEventListener('click', () => {
            postTypeInsights('.page-home .future-radar-section .actions');
        }));
    }

    //filter all by clicking only sticky header
    const mainSection = selAll('.filter-heading.sh .single-office span');
    mainSection.forEach(btn => btn.addEventListener('click', () => {
        setTimeout(() => {
            filterPress('filter', mainSection);
            postTypeInsights('.page-home .future-radar-section .actions');
            // postTypeExperience('.page-home .splide-experience .splide__list', '.splide-experience');
        });
    }));

    if (sel('.splide-experience')) {
        const splideTitles = selAll('.slide-caption .text h4');

        splideTitles.forEach(title => {
            if (title.textContent.length > 66) {
                title.textContent = title.textContent.slice(0, 66) + '...';
            }
        });
    }

    if (sel('.single-service')) {
        const officeLocations = selAll('.people-main-section.filter-heading .main-offices .single-office');
        const currColor = localStorage.getItem('current-color');
        const persons = selAll('.people-main-section.filter-heading .single-person');
        const mainBlock = sel('.people-main-section.filter-heading #person-filter');

        let arr = [];

        if (currColor.includes('all')) {
            arr = ['all'];
        }

        if (currColor.includes('estonia')) {
            arr = ['estonia', 'eesti', 'igaunija', 'estija']
        }

        if (currColor.includes('latvia')) {
            arr = ['latvia', 'läti', 'latvija']
        }

        if (currColor.includes('lithuania')) {
            arr = ['lithuania', 'leedu', 'lietuva']
        }

        _.each(officeLocations, val => val.addEventListener('click', () => {
            const currColor = localStorage.getItem('current-color');
            mainBlock.classList.add('filtering-block');
            if (currColor.includes('all')) {
                arr = ['all'];
            }

            if (currColor.includes('estonia')) {
                arr = ['estonia', 'eesti', 'igaunija', 'estija']
            }

            if (currColor.includes('latvia')) {
                arr = ['latvia', 'läti', 'latvija']
            }

            if (currColor.includes('lithuania')) {
                arr = ['lithuania', 'leedu', 'lietuva']
            }

            setTimeout(() => {
                mainBlock.classList.remove('filtering-block');
                _.each(persons, person => {
                    person.classList.remove('active');
                });

                if (arr.includes('all')) {
                    _.each(persons, person => {
                        person.classList.add('active');
                    });
                }

                _.each(persons, person => {
                    const getCountry = person.getAttribute('data-country');


                    if (arr.includes(getCountry)) {
                        person.classList.add('active');
                    }
                });
            }, 1000);
        }));


        if (currColor.includes('all')) {
            officeLocations[0].click();
        }

        if (currColor.includes('estonia')) {
            officeLocations[1].click();
        }

        if (currColor.includes('latvia')) {
            officeLocations[2].click();
        }

        if (currColor.includes('lithuania')) {
            officeLocations[3].click();
        }
    }

    //click all
    if (sel('.page-home')) {
        const insights = selAll('.future-radar-section.filter-heading-inner .office-locations .single-office');
        const btns2 = selAll('.recent-experience-section.filter-heading-inner .single-office');

        _.each(insights, (val, i) => val.addEventListener('click', () => {
            btns2[i].click();
        }));

        _.each(btns2, (val, i) => val.addEventListener('click', () => {
            insights[i].click();
            BIG_PATCH();
        }));

        const placeHolder = document.createElement('div');
        const ins2 = [placeHolder, ...insights];
        const btns3 = [placeHolder, ...btns2];
        const firstHeader = selAll('.header-langs-diff .locations .single-office');
        const secondHeader = selAll('.second-header .people-main-section .single-office');

        _.each(secondHeader, (val, i) => val.addEventListener('click', () => {
            firstHeader[i].click();
        }));

        _.each(firstHeader, (val, i) => val.addEventListener('click', () => {
            secondHeader[i].click();
            ins2[i].click();
            btns3[i].click();
        }));
    }
    //

    if (sel('.page-template-page-contacts')) {
        const firstHeader = selAll('.header-langs-diff .locations .single-office');
        const secondHeader = selAll('.second-header .people-main-section .single-office');
        const filterContacts = selAll('.page-contacts .people-main-section .locations .single-office');

        _.each(secondHeader, (val, i) => val.addEventListener('click', () => {
            filterContacts[i].click();
        }));

        _.each(firstHeader, (val, i) => val.addEventListener('click', () => {
            filterContacts[i].click();
        }));
    }


    if (sel('.single-service .recent-experience-section') || sel('.single-people .recent-experience-section')) {

        const experiences = selAll('.single-service .splide-person-experience .splide__slide, .single-people .splide-person-experience .splide__slide');
        const experiencesCopy = [...experiences];
        const splideBlock = sel('.single-service .splide-person-experience .splide__list') || sel('.single-people .splide-person-experience .splide__list');

        let splideClients = new Splide('.splide-person-experience', {
            type: 'slide',
            perPage: 3,
            perMove: 1,
            speed: 600,
            easing: 'cubic-bezier(0.445, 0.05, 0.55, 0.95)',
            pagination: false,
            arrows: false,
            fixedWidth: '26.25vw',
            fixedHeight: '41.5vw',
            gap: 16,
            flickPower: 150,
            flickMaxPages: 1,
            // padding: { right: '10%' },
            breakpoints: {
                769: {
                    perPage: 1,
                    fixedWidth: '80.4%',
                    fixedHeight: '150vw',
                    gap: 20,

                    autoHeight: true,
                },
            }
        }).mount();


        const fetchExperiences = function () {
            if (!sel('.single-service .recent-experience-section') && !sel('.single-people .recent-experience-section')) return;

            splideBlock.classList.add('filtering-block');

            setTimeout(() => {
                splideBlock.innerHTML = '';
                splideClients.destroy();

                const sectionSelector =
                    sel('.single-service .recent-experience-section') ||
                    sel('.single-people .recent-experience-section');

                const currentColor = (localStorage.getItem('current-color') || 'all').toLowerCase();

                // If "all" (or missing) -> show all
                if (currentColor.includes('all')) {
                    experiencesCopy.forEach(experience => {
                        splideBlock.insertAdjacentElement('beforeend', experience);
                    });
                } else {
                    const matched = [];

                    experiencesCopy.forEach(experience => {
                        const dataCountry = experience.getAttribute('data-country') || '';
                        const countries = dataCountry
                            .split(' | ')
                            .map(c => c.toLowerCase().trim())
                            .filter(Boolean);

                        const hasMatch = countries.some(country => {
                            let resCountry = '';

                            if (country.includes('lithuan') || country.includes('leedu') || country.includes('lietuva')) {
                                resCountry = 'lithuania';
                            } else if (country.includes('latvia') || country.includes('läti') || country.includes('latvija')) {
                                resCountry = 'latvia';
                            } else if (country.includes('estonia') || country.includes('eesti') || country.includes('igaunija') || country.includes('estija')) {
                                resCountry = 'estonia';
                            }

                            return resCountry === currentColor;
                        });

                        if (hasMatch) {
                            matched.push(true);
                            splideBlock.insertAdjacentElement('beforeend', experience);
                        }
                    });

                    // ✅ IMPORTANT: if nothing matched, show all instead of hiding the section
                    if (!matched.length) {
                        experiencesCopy.forEach(experience => {
                            splideBlock.insertAdjacentElement('beforeend', experience);
                        });
                    }
                }

                // ✅ Display rules: show section only if there are slides
                if (sectionSelector) {
                    sectionSelector.style.display = splideBlock.children.length ? 'block' : 'none';
                }

                splideBlock.classList.remove('filtering-block');

                splideClients.mount();
            });
        };


        //for testing
        setTimeout(() => {
            fetchExperiences();
        });

        const headerOffices = selAll('.filter-heading.sh .single-office');
        const headerLangs = selAll('.header-langs-diff .people-main-section .single-office');
        const serviceLangs = selAll('.single-services .people-main-section .locations .single-office');

        _.each(headerLangs, office => office.addEventListener('click', () => {
            setTimeout(() => {

                fetchExperiences();
            });
        }))
        //

        _.each(headerOffices, office => office.addEventListener('click', () => {
            setTimeout(() => {
                fetchExperiences();
            });
        }));

        _.each(serviceLangs, office => office.addEventListener('click', () => {
            setTimeout(() => {
                fetchExperiences();
            });
        }));


    }

    // Splide for speakers carousel (single-insights)
    if (document.querySelector('.splide-speakers')) {
        new Splide('.splide-speakers', {
            type: 'slide',
            perPage: 4,
            perMove: 1,
            speed: 600,
            easing: 'cubic-bezier(0.445, 0.05, 0.55, 0.95)',
            pagination: false,
            arrows: false,
            gap: 16,
            breakpoints: {
                769: {
                    fixedWidth: '38.9vw',
                    perPage: 1,
                    width: '90.5vw',
                    autoWidth: true,
                    autoHeight: true
                }
            }
        }).mount();
    }

    const fetchContent = function () {
        //page about
        //about for en +

        //page-home
        if (sel('.page-home')) {
            const id = sel('main').getAttribute('data-page');

            //top block +
            fetchField('text', id, 'Homepage', 'pageHome', 'home_1_title_gr', localStorage.getItem('current-color'), '.top-section .content .left-side .title h1');
            fetchField('text', id, 'Homepage', 'pageHome', 'home_1_caption_gr', localStorage.getItem('current-color'), '.top-section .content .left-side .caption span');
            //

            //practices
            fetchField('repeater-m-2', id, 'Homepage', 'pageHome', `home_new_3_practice_areas_${localStorage.getItem('current-color')}`, localStorage.getItem('current-color'), '.dark-section .content');
            //

            //main section
            fetchField('text', id, 'Homepage', 'pageHome', 'home_2_subtitle_gr', localStorage.getItem('current-color'), '.our-offices-section .subtitle h5');
            fetchField('repeater-3', id, 'Homepage', 'pageHome', `home_new_new_2_2_content_${localStorage.getItem('current-color')}`, localStorage.getItem('current-color'), '.our-offices-section .offices-block');
            //

            //philosophies
            fetchField('text', id, 'Homepage', 'pageHome', 'home_6_subtitle_gr', localStorage.getItem('current-color'), '.triniti-philosophy-section .section-heading h5');
            fetchField('repeater-2-philosophy', id, 'Homepage', 'pageHome', `home_new_6_philosophies_${localStorage.getItem('current-color')}`, localStorage.getItem('current-color'), '.triniti-philosophy-section');
            //
        }
        //

        if (sel('.page-template-page-about')) {
            // id = 28;
            const id = sel('main').getAttribute('data-page');
            //top block +
            fetchField('text', id, 'About', 'pageAbout', 'about_1_caption_gr', localStorage.getItem('current-color'), '.top-section-inner .content .left-side .text', 'animated');
            //

            //main +
            fetchField('text', id, 'About', 'pageAbout', 'about_2_title_gr', localStorage.getItem('current-color'), '.about-main-section .content .left-side h2');
            fetchField('text', id, 'About', 'pageAbout', 'about_2_text_gr', localStorage.getItem('current-color'), '.about-main-section .content .right-side .text');
            fetchField('img', id, 'About', 'pageAbout', 'about_2_photo_gr', localStorage.getItem('current-color'), '.about-main-section .bottom-block .photo');
            //

            //brand birth +
            fetchField('text', id, 'About', 'pageAbout', 'about_3_subtitle_gr', localStorage.getItem('current-color'), '.brand-birth-section .section-subtitle h5');
            fetchField('repeater', id, 'About', 'pageAbout', `about_3_text_${localStorage.getItem('current-color')}`, localStorage.getItem('current-color'), '.brand-birth-section .top-text');
            fetchField('repeater-carousel', id, 'About', 'pageAbout', `about_4_photos_${localStorage.getItem('current-color')}`, localStorage.getItem('current-color'), '.brand-birth-section .splide-working .splide__list');
            //

            //milestones +
            fetchField('text', id, 'About', 'pageAbout', 'about_8_subtitle_gr', localStorage.getItem('current-color'), '.key-milestones .section-subtitle h5');
            fetchField('carousel-2', id, 'About', 'pageAbout', `about_8_slides_${localStorage.getItem('current-color')}`, localStorage.getItem('current-color'), '.key-milestones .carousel-milestones .splide-milestones .splide__list');
            //

            //philosophies +
            fetchField('text', id, 'About', 'pageAbout', 'about_4_subtitle_gr', localStorage.getItem('current-color'), '.triniti-about-philosophy .section-subtitle h5');
            fetchField('repeater-2', id, 'About', 'pageAbout', `about_4_philosophies_${localStorage.getItem('current-color')}`, localStorage.getItem('current-color'), '.triniti-about-philosophy .items-block');
            //

            //culture +
            fetchField('text', id, 'About', 'pageAbout', 'about_5_subtitle_gr', localStorage.getItem('current-color'), '.triniti-culture .subtitle h5');
            fetchField('img', id, 'About', 'pageAbout', 'about_5_photo_gr', localStorage.getItem('current-color'), '.triniti-culture .left-side .photo');
            fetchField('text', id, 'About', 'pageAbout', 'about_5_caption_gr', localStorage.getItem('current-color'), '.triniti-culture .right-side .heading h4');
            fetchField('text', id, 'About', 'pageAbout', 'about_5_text_gr', localStorage.getItem('current-color'), '.triniti-culture .right-side .text');
            //

            //card +
            fetchField('text', id, 'About', 'pageAbout', 'about_6_subtitle_gr', localStorage.getItem('current-color'), '.caption-section .left-side .caption h5');
            fetchField('text', id, 'About', 'pageAbout', 'about_6_text_gr', localStorage.getItem('current-color'), '.caption-section .right-side .text h4');
            //
        }

        //page career
        if (sel('.page-career-jurex')) {
            // id = 36;
            const id = sel('main').getAttribute('data-page');
            //top block +
            fetchField('text', id, 'Career', 'pageCareer', 'career_1_top_text_gr', localStorage.getItem('current-color'), '.top-section-inner .content .left-side .text', 'animated');
            //

            //main block +
            fetchField('text', id, 'Career', 'pageCareer', 'career_2_subtitle_gr', localStorage.getItem('current-color'), '.brand-birth-section .section-subtitle h5');
            fetchField('repeater', id, 'Career', 'pageCareer', `career_2_top_text_${localStorage.getItem('current-color')}`, localStorage.getItem('current-color'), '.brand-birth-section .top-text');
            fetchField('repeater-carousel', id, 'Career', 'pageCareer', `career_2_carousel_${localStorage.getItem('current-color')}`, localStorage.getItem('current-color'), '.brand-birth-section .carousel-block .splide-working .splide__list');
            fetchField('repeater-2', id, 'Career', 'pageCareer', `career_2_expectations_${localStorage.getItem('current-color')}`, localStorage.getItem('current-color'), '.brand-birth-section .bottom-block .items-block');
            //

            //card
            fetchField('group-3', id, 'Career', 'pageCareer', `career_3_card_${localStorage.getItem('current-color')}`, localStorage.getItem('current-color'), '.caption-section .content');
            //
        }
        //

        //page privacy policy
        if (sel('.page-template-page-privacy-policy')) {
            const id = sel('main').getAttribute('data-page');
            //top block +
            fetchField('text', id, 'Privacypolicy', 'pagePrivacyPolicy', 'privacy_title_gr', localStorage.getItem('current-color'), '.top-section-inner .content .title h1', 'animated');
            fetchField('text', id, 'Privacypolicy', 'pagePrivacyPolicy', 'privacy_caption_gr', localStorage.getItem('current-color'), '.top-section-inner .content .text', 'animated');
            //

            //main repeater
            fetchField('repeater-policy-3', id, 'Privacypolicy', 'pagePrivacyPolicy', `privacy_policy_content_${localStorage.getItem('current-color')}`, localStorage.getItem('current-color'), '.main-policies .wrapper');
            //
        }
        //

        //page people
        if (sel('.page-template-page-people')) {
            // id = 41;
            const id = sel('main').getAttribute('data-page');
            //top block +
            fetchField('text', id, 'People', 'pagePeople', 'people_1_caption_gr', localStorage.getItem('current-color'), '.top-section-inner .content .left-side .text', 'animated');
            //
        }
        //

        //page services
        if (sel('.page-template-page-services')) {
            // id = 79;
            const id = sel('main').getAttribute('data-page');
            //top block +
            fetchField('text', id, 'Services', 'pageExpertises', 'services_1_caption_gr', localStorage.getItem('current-color'), '.top-section-inner .content .left-side .text', 'animated');
            //
        }
        //

        //page experience
        if (sel('.page-template-page-experience')) {
            // id = 103;
            const id = sel('main').getAttribute('data-page');
            //top block +
            fetchField('text', id, 'Experience', 'pageExperience', 'experience_1_caption_gr', localStorage.getItem('current-color'), '.top-section-inner .content .left-side .text', 'animated');
            //
        }
        //

        //page insights
        if (sel('.page-template-page-insights')) {
            // id = 128;
            const id = sel('main').getAttribute('data-page');
            //top block +
            fetchField('text', id, 'Insights', 'pageInsights', 'insights_1_caption_gr', localStorage.getItem('current-color'), '.top-section-inner .content .left-side .text', 'animated');
            //
        }
        //

        //single post type service
        if (sel('.single-services')) {
            const currPostId = sel('main').getAttribute('data-page');
            //top block
            fetchPostField('text', currPostId, 'service', `service_inner_caption_gr`, localStorage.getItem('current-color'), `.top-section-inner .content .left-side .text`, 'animated');
            fetchPostField('repeater', currPostId, 'service', `service_inner_description_${localStorage.getItem('current-color')}`, localStorage.getItem('current-color'), `.top-section-inner .full-description .full-text`);
            //

            //we help clients repeater
            fetchPostField('text', currPostId, 'service', `service_inner_2_title_gr`, localStorage.getItem('current-color'), `.single-service-client-help .filter-block h2`);
            fetchPostField('repeater-2', currPostId, 'service', `service_inner_2_subpractices_${localStorage.getItem('current-color')}`, localStorage.getItem('current-color'), '.single-service-client-help .table-body');
            //

            //experience
            fetchPostField('text', currPostId, 'service', `service_inner_3_text_gr`, localStorage.getItem('current-color'), `.recent-experience-section .subtitle .text`);
            //

            //insights/publications
            fetchPostField('repeater-2', currPostId, 'service', `service_inner_4_insights_or_publications_${localStorage.getItem('current-color')}`, localStorage.getItem('current-color'), '.personal-table .table-content');
            //

            //card
            fetchPostField('repeater-4', currPostId, 'service', `service_inner_3_card_${localStorage.getItem('current-color')}`, localStorage.getItem('current-color'), '.caption-section .content');
            //
        }
        //
    }

    const headerLangs = selAll('.header-langs-diff .people-main-section .main-offices .single-office, .second-header .people-main-section .main-offices .single-office');

    fetchContent();
    _.each(headerLangs, lang => lang.addEventListener('click', () => {
        fetchContent();
        BIG_PATCH();
    }));

    if (sel('.new-events')) {
        const btns = selAll('.new-events .btn-stroke a');
        const sin = selAll('.new-events .agenda .sin-wrapper');

        _.each(btns, (btn, i) => btn.addEventListener('click', () => {
            _.each(btns, btn => btn.classList.remove('active'));
            btn.classList.add('active');

            _.each(sin, el => {
                el.classList.remove('active')
                el.classList.add('inactive')
            });
            sin[i].classList.add('active');
        }));
    }

    // Setup load more functionality for insights/blogs/news on single-people page
    const setupLoadMore = function (itemSelector, buttonSelector, initialCount) {
        if (!sel(itemSelector) || !sel(buttonSelector)) return;

        const items = selAll(itemSelector);
        const button = sel(buttonSelector);

        // Show first N items
        for (let i = 0; i < initialCount && i < items.length; i++) {
            items[i].classList.add('active');
        }

        // Hide button if all items are shown
        if (initialCount >= items.length) {
            button.style.display = 'none';
        } else {
            button.style.display = 'block';
        }

        // Add click handler to load more button
        button.addEventListener('click', function(e) {
            e.preventDefault();
            let visibleCount = 0;

            // Count currently visible items
            items.forEach(item => {
                if (item.classList.contains('active')) visibleCount++;
            });

            // Show next batch of items (6 at a time)
            for (let i = visibleCount; i < visibleCount + 6 && i < items.length; i++) {
                items[i].classList.add('active');
            }

            // Hide button if all items are now visible
            visibleCount = 0;
            items.forEach(item => {
                if (item.classList.contains('active')) visibleCount++;
            });

            if (visibleCount >= items.length) {
                button.style.display = 'none';
            }
        });
    };

    // Initialize load more for blogs
    setupLoadMore('.future-radar-section.blogs .actions .single-action', '.future-radar-section.blogs .load-more-posts', 6);

    // Initialize load more for news
    setupLoadMore('.future-radar-section.news .actions .single-action', '.future-radar-section.news .load-more-posts', 6);

    // Initialize experience carousel slides visibility
    if (sel('.single-people .recent-experience-section')) {
        const slides = selAll('.single-people .recent-experience-section .splide__slide');
        slides.forEach(slide => {
            slide.classList.remove('hidden');
        });
    }

    // Mount Splide carousel for person experience
    if (document.querySelector('.splide-person-experience')) {
        new Splide('.splide-person-experience', {
            type: 'slide',
            perPage: 4,
            perMove: 1,
            speed: 600,
            easing: 'cubic-bezier(0.445, 0.05, 0.55, 0.95)',
            pagination: false,
            arrows: false,
            fixedWidth: '26.25vw',
            fixedHeight: '42vw',
            gap: 16,
            breakpoints: {
                769: {
                    type: 'slide',
                    drag: false,
                    fixedWidth: '88.5%',
                    fixedHeight: '150vw',
                    autoHeight: true,
                }
            }
        }).mount();
    }
});

/* ========================================================================== */
/*  MISSING FROM BUILD (webpack module 1434)                                  */
/*  Paste at the END of your current main.js                                  */
/* ========================================================================== */

(() => {
    // Safe fallbacks (won't redeclare your existing variables)
    const _sel =
        typeof sel !== "undefined"
            ? sel
            : (s, root = document) => root.querySelector(s);

    const _selAll =
        typeof selAll !== "undefined"
            ? selAll
            : (s, root = document) => Array.from(root.querySelectorAll(s));

    const _screenWidth =
        typeof screenWidth !== "undefined"
            ? screenWidth
            : window.matchMedia("(max-width: 768px)");

    const withJQ = (fn) => {
        if (window.jQuery) fn(window.jQuery);
    };

    const once = (key, fn) => {
        window.__mainJsOnce = window.__mainJsOnce || {};
        if (window.__mainJsOnce[key]) return;
        window.__mainJsOnce[key] = true;
        fn();
    };

    const oncePerEl = (el, key) => {
        if (!el) return false;
        const k = `__${key}`;
        if (el.dataset[k] === "1") return false;
        el.dataset[k] = "1";
        return true;
    };

    const smoothScrollTo = (el, offset = -100) => {
        if (!el) return;
        const top = el.getBoundingClientRect().top + window.pageYOffset + offset;
        window.scrollTo({ top, behavior: "smooth" });
    };

    /* ------------------------------------------------------------------------ */
    /* DOM READY (jQuery(document).ready)                                       */
    /* ------------------------------------------------------------------------ */

    function initDomReadyFromBuild() {
        // Header search toggle
        withJQ(($) => {
            const searchInput = _sel(".orig");
            $(".promagnifier")
                .off("click.__buildSearch")
                .on("click.__buildSearch", () => {
                    $(".proinput").toggleClass("active");
                    searchInput?.focus();
                });
        });

        // Services page: auto-select last filter item (when no query string)
        if (_sel(".page-template-page-services")) {
            if (!window.location.href.includes("?")) {
                _sel(
                    ".sf-field-taxonomy-service_expertises .sf-level-0:last-of-type label"
                )?.click();
            }
        }

        // Splide: ".splide-working"
        if (document.querySelector(".splide-working") && window.Splide) {
            const root = document.querySelector(".splide-working");
            if (oncePerEl(root, "splideWorkingMounted")) {
                new Splide(".splide-working", {
                    type: "loop",
                    perPage: 4,
                    perMove: 1,
                    speed: 600,
                    easing: "cubic-bezier(0.445, 0.05, 0.55, 0.95)",
                    pagination: false,
                    arrows: false,
                    fixedWidth: "26.25vw",
                    fixedHeight: "33.854166666666664vw",
                    gap: 16,
                    breakpoints: {
                        769: {
                            gap: 8,
                            fixedWidth: "65vw",
                            fixedHeight: "84.73333333333333vw",
                        },
                    },
                }).mount();
            }
        }

        // Home (mobile): hide recent experience slides after 3rd
        const hideHomeRecentExperienceSlides = () => {
            if (!_screenWidth.matches) return;
            if (!_sel(".page-home")) return;
            _selAll(".recent-experience-section .splide__slide").forEach(
                (slide, idx) => {
                    if (idx >= 3) slide.classList.add("hidden");
                }
            );
        };
        hideHomeRecentExperienceSlides();

        // If AJAX filtering happens, re-apply mobile hiding
        withJQ(($) => {
            $(document).ajaxComplete(() => {
                hideHomeRecentExperienceSlides();
            });
        });

        // Single people: fix contact cards hrefs in second/third columns
        if (_sel(".single-people")) {
            // second-column: copy the <p><a href> onto the outer <a>
            if (_sel(".second-column .contacts")) {
                _selAll(".second-column .contacts").forEach((wrap) => {
                    const href =
                        wrap.querySelector(".second-column .single-contact p > a")?.getAttribute(
                            "href"
                        ) || "";
                    if (!href) return;
                    wrap.querySelector(".single-contact > a")?.setAttribute("href", href);
                });
            }

            // third-column: copy first <a href> onto last <a>
            if (_sel(".third-column .contacts")) {
                _selAll(".third-column .contacts").forEach((wrap) => {
                    const href =
                        wrap.querySelector(".single-contact > a")?.getAttribute("href") || "";
                    if (!href) return;
                    wrap
                        .querySelector(".single-contact > a:last-of-type")
                        ?.setAttribute("href", href);
                });
            }
        }

        // Hide/show ajax result description if empty
        const toggleAjaxResultDescription = () => {
            const desc = _sel(".is-ajax-result-description");
            if (!desc) return;
            desc.style.display =
                desc.textContent.trim().toLowerCase().length < 1 ? "none" : "block";
        };
        toggleAjaxResultDescription();
        withJQ(($) => $(document).ajaxComplete(toggleAjaxResultDescription));

        // Truncate person experience titles (66 chars) like in build
        if (_sel(".splide-person-experience")) {
            _selAll(".splide-person-experience .slide-caption .text h4").forEach(
                (h) => {
                    if ((h.textContent || "").length > 66) {
                        h.textContent = h.textContent.slice(0, 66) + "...";
                    }
                }
            );
        }

        // Smooth scroll anchors
        withJQ(($) => {
            $('.smooth[href*="#"], .smooth a[href*="#"]')
                .off("click.__buildSmooth")
                .on("click.__buildSmooth", function () {
                    if (
                        location.pathname.replace(/^\//, "") ===
                        this.pathname.replace(/^\//, "") &&
                        location.hostname === this.hostname
                    ) {
                        let target = $(this.hash);
                        target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
                        if (target.length) {
                            $("html,body").animate({ scrollTop: target.offset().top }, 1000);
                            return false;
                        }
                    }
                });
        });

        // Header language short codes (ET->EE, SV->SE)
        _selAll("header .langs-warn .wpml-ls-native").forEach((node) => {
            const t = (node.textContent || "").trim().toLowerCase();
            if (t.includes("et")) node.textContent = "EE";
            if (t.includes("sv")) node.textContent = "SE";
        });

        // Header scrolled class after 300px
        withJQ(($) => {
            const $header = $("header");
            const apply = () => {
                if ($(window).scrollTop() >= 300) $header.addClass("scrolled");
                else $header.removeClass("scrolled");
            };
            $(window).off("scroll.__buildHeader").on("scroll.__buildHeader", apply);
            apply();
        });

        // Responsive menu toggles
        withJQ(($) => {
            $(".resp-btn, .resp-close")
                .off("click.__buildResp")
                .on("click.__buildResp", function () {
                    $(this).toggleClass("active-btn");
                    $(".meniu").toggleClass("active-menu");
                });
        });

        // MagnificPopup inits (popup-modal + apply-modal-btn)
        withJQ(($) => {
            if (!$.fn.magnificPopup) return;

            const popupCfg = {
                type: "inline",
                fixedContentPos: true,
                fixedBgPos: true,
                overflowY: "auto",
                closeBtnInside: false,
                preloader: false,
                midClick: true,
                removalDelay: 300,
                mainClass: "my-mfp-zoom-in",
                closeOnBgClick: true,
                enableEscapeKey: true,
            };

            $(".popup-modal").magnificPopup(popupCfg);
            $(".apply-modal-btn").magnificPopup(popupCfg);

            $(document)
                .off("click.__buildPopupDismiss")
                .on("click.__buildPopupDismiss", ".popup-modal-dismiss", (e) => {
                    e.preventDefault();
                    $.magnificPopup.close();
                });
        });

        // Career select: select2 + click language modal button
        if (_sel(".page-career") || _sel(".single-career")) {
            withJQ(($) => {
                if (!$.fn.select2) return;
                const $select = $("#career-select");
                if (!$select.length) return;

                if (!$select.data("__buildSelect2")) {
                    $select.data("__buildSelect2", true);
                    $select.select2({ minimumResultsForSearch: -1, dropdownAutoWidth: true });
                }

                $select.off("change.__buildCareer").on("change.__buildCareer", (ev) => {
                    const idx = ev.target.selectedIndex - 1;
                    const btns = _selAll(".apply-modal-lang");
                    btns[idx]?.click();
                });
            });
        }

        // Select2 for Search&Filter selects
        withJQ(($) => {
            if (!$.fn.select2) return;
            // prevent double-init loops
            $(".sf-input-select").each(function () {
                const $el = $(this);
                if ($el.data("__buildSelect2")) return;
                $el.data("__buildSelect2", true);
                $el.select2({ minimumResultsForSearch: -1 });
            });
        });

        // Pagination: scroll back to filter heading
        const initFilterPaginationScroll = () => {
            const pagination = _sel(".filter-pagination");
            if (!pagination) return;

            const links = _selAll(".filter-pagination .page-numbers:not(.current, .dots)");
            const heading = _sel("main .filter-heading");

            links.forEach((a) => {
                if (oncePerEl(a, "paginationScrollBound")) {
                    a.addEventListener("click", () => smoothScrollTo(heading, -100));
                }
            });
        };
        initFilterPaginationScroll();

        /* Sticky office photos (home / insights) */
        const initStickyOfficePhotos = () => {
            const photosRoot =
                _sel(".page-home .our-offices-section .right-photos-sticky") ||
                _sel(".page-insights .right-photos-sticky");

            if (!photosRoot) return;
            if (!oncePerEl(photosRoot, "stickyOfficePhotos")) return;

            const photos = _selAll(".our-offices-section .right-photos-sticky .photo");
            const offices = _selAll(".our-offices-section .single-office");
            const seen = [];

            const update = () => {
                offices.forEach((office, idx) => {
                    const top = office.getBoundingClientRect().top;
                    if (top - document.documentElement.clientHeight / 2 < 0) {
                        seen.push(office);

                        // Reset
                        if (!_sel(".page-insights")) {
                            seen.forEach((o) => o.querySelector(".blured")?.classList.remove("active"));
                        }
                        photos.forEach((p) => p.classList.remove("active"));

                        // Activate current
                        photos[idx]?.classList.add("active");
                        seen[seen.length - 1]?.querySelector(".blured")?.classList.add("active");
                    }
                });
            };

            update();
            window.addEventListener("scroll", update);
        };

        initStickyOfficePhotos();

        // AJAX complete: re-run sticky + pagination + select2, and do people-filter "load more button move" like build
        withJQ(($) => {
            $(document).ajaxComplete(() => {
                initStickyOfficePhotos();
                initFilterPaginationScroll();

                // Re-init select2 if new selects inserted by AJAX
                if ($.fn.select2) {
                    $(".sf-input-select").each(function () {
                        const $el = $(this);
                        if ($el.data("__buildSelect2")) return;
                        $el.data("__buildSelect2", true);
                        $el.select2({ minimumResultsForSearch: -1 });
                    });
                }

                // Build behavior: replace a .load-more-posts element with styled wrapper after #person-filter
                const oldLoadMore = _sel(".load-more-posts");
                const after = _sel("#person-filter");
                if (oldLoadMore && after && !oldLoadMore.dataset.__buildMoved) {
                    oldLoadMore.dataset.__buildMoved = "1";

                    const label = oldLoadMore.querySelector("a")?.textContent || "";
                    oldLoadMore.remove();

                    const wrapper = document.createElement("div");
                    wrapper.classList.add("load-more-posts", "btn-stroke");

                    const link = document.createElement("a");
                    link.textContent = label;
                    wrapper.appendChild(link);

                    after.insertAdjacentElement("afterend", wrapper);
                }
            });
        });

        // Caption section: set right-side height to tallest text block (desktop)
        if (_sel(".caption-section") && !_screenWidth.matches) {
            const heights = _selAll(".caption-section .right-side .text")
                .map((el) => el.clientHeight)
                .sort((a, b) => a - b);

            const rightSide = _sel(".caption-section .right-side");
            const max = heights[heights.length - 1] || 0;

            if (rightSide && max) {
                rightSide.style.height = `${max / (document.documentElement.clientWidth / 100)}vw`;
            }
        }

        // Page people: make all person cards active (build behavior)
        if (_sel(".page-people")) {
            _selAll(".page-people .single-person").forEach((card) => card.classList.add("active"));
        }

        // Single people: hide insights/news actions after 6 (build behavior)
        if (_sel(".single-people")) {
            _selAll(".single-people .insights-news .actions .single-action").forEach((a, idx) => {
                if (idx > 5) a.classList.remove("active");
            });
        }
    }

    /* ------------------------------------------------------------------------ */
    /* WINDOW LOAD (build had a large setTimeout(0) block)                      */
    /* ------------------------------------------------------------------------ */

    function initOnLoadFromBuild() {
        // Prevent double-init if your theme already does this elsewhere
        once("buildLoadInit", () => {
            setTimeout(() => {
                const html = document.documentElement;
                const body = document.body;
                const locale = html.getAttribute("lang") || "en";

                /* RU warning banner (build behavior) */
                if ((html.getAttribute("lang") || "").includes("ru")) {
                    if (!_sel(".warn-ru.get-warn")) {
                        const warn = document.createElement("div");
                        warn.classList.add("warn-ru", "get-warn", "active");
                        warn.innerHTML = `
              <div class="wrapper">
                <div class="warn-text">
                  <p>Предоставление юридических услуг российским и белорусским компаниям в настоящее время ограничено из-за войны против Украины.</p>
                  <div class="hide"></div>
                </div>
              </div>
            `;
                        body.insertAdjacentElement("afterbegin", warn);
                    }
                }

                _selAll(".get-warn .hide").forEach((btn) => {
                    if (oncePerEl(btn, "warnDismiss")) {
                        btn.addEventListener("click", () => btn.closest(".get-warn")?.classList.remove("active"));
                    }
                });

                /* Sidebar hamburger open/close (build behavior) */
                const sidebar = document.querySelector(".sidebar");
                const sidebarBg = document.querySelector(".sidebar-bg");
                const hambButtons = _selAll(".hamb-menu");
                const progressBars = _selAll(".progress-bar__progress");
                const desktopHeader = document.querySelector(".desktop-header");
                const logo = _sel(".desktop-header .logo");

                if (sidebar && sidebarBg && hambButtons.length) {
                    let open = false;

                    const close = (btn) => {
                        btn.classList.remove("animate-hamb");
                        btn.classList.add("animate-hamb-reverse");

                        sidebar.classList.remove("active");
                        sidebarBg.classList.remove("active");
                        logo?.classList.remove("blured-logo");

                        hambButtons.forEach((b) => (b.style.pointerEvents = "none"));
                        btn.classList.remove("active");
                        progressBars.forEach((p) => p.classList.remove("active"));

                        body.classList.remove("overflow-toggle");
                        html.classList.remove("overflow-toggle");
                        desktopHeader?.classList.remove("sidebar-open");

                        setTimeout(() => {
                            hambButtons.forEach((b) => (b.style.pointerEvents = "all"));
                        }, 400);
                    };

                    hambButtons.forEach((btn, idx) => {
                        if (!oncePerEl(btn, "hambBound")) return;

                        btn.addEventListener("click", () => {
                            btn.classList.toggle("active");
                            progressBars[idx]?.classList.toggle("active");
                            open = !open;

                            hambButtons.forEach((b) => (b.style.pointerEvents = "none"));
                            setTimeout(() => hambButtons.forEach((b) => (b.style.pointerEvents = "all")), 600);

                            if (open) {
                                btn.classList.remove("animate-hamb-reverse");
                                btn.classList.add("animate-hamb", "active");

                                sidebar.classList.add("active");
                                sidebarBg.classList.add("active");
                                logo?.classList.add("blured-logo");

                                body.classList.add("overflow-toggle");
                                html.classList.add("overflow-toggle");
                                desktopHeader?.classList.add("sidebar-open");
                            } else {
                                close(btn);
                            }
                        });
                    });

                    if (oncePerEl(sidebarBg, "sidebarBgClose")) {
                        sidebarBg.addEventListener("click", () => {
                            hambButtons.forEach((btn) => close(btn));
                            desktopHeader?.classList.remove("sidebar-open");
                        });
                    }

                    once("sidebarEscClose", () => {
                        window.addEventListener("keydown", (e) => {
                            if (e.key !== "Escape") return;
                            hambButtons.forEach((btn) => close(btn));
                            desktopHeader?.classList.remove("sidebar-open");
                        });
                    });
                }

                /* Splide: single-experience */
                if (_sel(".single-experience .splide-experience") && window.Splide) {
                    const root = _sel(".single-experience .splide-experience");
                    if (oncePerEl(root, "splideSingleExperienceMounted")) {
                        new Splide(".splide-experience", {
                            type: "slide",
                            perPage: 4,
                            perMove: 1,
                            speed: 600,
                            easing: "cubic-bezier(0.445, 0.05, 0.55, 0.95)",
                            pagination: false,
                            arrows: false,
                            fixedWidth: "26.25vw",
                            fixedHeight: "42vw",
                            gap: 16,
                            breakpoints: {
                                769: { fixedWidth: "88.5%", fixedHeight: "150vw", autoHeight: true },
                            },
                        }).mount();
                    }
                }

                /* Splide: milestones */
                if (_sel(".splide-milestones") && window.Splide) {
                    const root = _sel(".splide-milestones");
                    if (oncePerEl(root, "splideMilestonesMounted")) {
                        const startIndex = _screenWidth.matches ? 0 : 1;
                        const milestones = new Splide(".splide-milestones", {
                            type: "slide",
                            start: startIndex,
                            perPage: 4,
                            perMove: 1,
                            speed: 600,
                            easing: "cubic-bezier(0.445, 0.05, 0.55, 0.95)",
                            pagination: false,
                            arrows: false,
                            fixedWidth: "12.708333333333334vw",
                            breakpoints: {
                                769: { start: startIndex, focus: 0, perPage: 3, fixedWidth: "50.4vw" },
                            },
                        }).mount();

                        milestones.on("click", (evt) => milestones.go(evt.index));
                    }
                }

                /* Splide: person experience (multiple instances) */
                if (_sel(".splide-person-experience") && window.Splide) {
                    _selAll(".splide-person-experience").forEach((root) => {
                        if (!oncePerEl(root, "splidePersonExperienceMounted")) return;

                        const slideCount = root.querySelectorAll(".splide__slide").length;
                        new Splide(root, {
                            type: "slide",
                            perPage: 3,
                            perMove: 1,
                            speed: 600,
                            easing: "cubic-bezier(0.445, 0.05, 0.55, 0.95)",
                            pagination: false,
                            arrows: false,
                            fixedWidth: "26.25vw",
                            gap: 16,
                            flickPower: 150,
                            flickMaxPages: 1,
                            drag: _screenWidth.matches ? slideCount > 1 : slideCount > 3,
                            breakpoints: {
                                769: {
                                    perPage: 1,
                                    fixedWidth: "80.4%",
                                    fixedHeight: "150vw",
                                    gap: 20,
                                    autoHeight: true,
                                },
                            },
                        }).mount();
                    });
                }

                /* Home: top caption scroll to offices */
                if (_sel(".page-home")) {
                    const caption = _sel(".page-home .top-section .top-caption");
                    const target = _sel(".page-home .our-offices-section");
                    if (caption && oncePerEl(caption, "homeCaptionScroll")) {
                        caption.addEventListener("click", () => smoothScrollTo(target, -100));
                    }
                }

                /* Philosophy hover interactions (home) */
                if (_sel(".triniti-philosophy-section .philosophy-options")) {
                    const texts = _selAll(".triniti-philosophy-section .top-content > .single-text");
                    const opts = _selAll(".triniti-philosophy-section .philosophy-options > .single-philosophy");

                    opts.forEach((opt, idx) => {
                        if (!oncePerEl(opt, "philoHover")) return;

                        opt.addEventListener("mouseover", () => {
                            opts.forEach((o, j) => j !== idx && o.classList.add("inactive"));
                            texts[idx]?.classList.add("active");
                        });

                        opt.addEventListener("mouseout", () => {
                            opts.forEach((o) => o.classList.remove("inactive"));
                            texts[idx]?.classList.remove("active");
                        });
                    });
                }

                /* Business section: move right side while scrolling */
                if (_sel(".section-business")) {
                    const section = _sel(".section-business");
                    const right = _sel(".section-business .right-side");
                    if (section && right && oncePerEl(section, "businessScroll")) {
                        window.addEventListener("scroll", () => {
                            const rect = section.getBoundingClientRect();
                            if (rect.top < 0 && rect.bottom - window.innerHeight / 1.6 > 0) {
                                right.style.top = `${Math.abs(rect.top / (window.innerWidth / 100))}vw`;
                            }
                        });
                    }
                }

                /* Events agenda tabs */
                if (_sel(".single-events .single-day")) {
                    const days = _selAll(".single-events .single-day");
                    const agendas = _selAll(".single-events .events-agenda");

                    days.forEach((day, idx) => {
                        if (!oncePerEl(day, "eventsDayTab")) return;
                        day.addEventListener("click", () => {
                            days.forEach((d) => d.classList.remove("active"));
                            agendas.forEach((a) => a.classList.remove("active"));
                            day.classList.add("active");
                            agendas[idx]?.classList.add("active");
                        });
                    });
                }

                /* About page philosophy hover */
                if (_sel(".page-about .triniti-about-philosophy .single-philosophy")) {
                    const opts = _selAll(".page-about .triniti-about-philosophy .single-philosophy");
                    const texts = _selAll(".page-about .triniti-about-philosophy .single-text");

                    opts.forEach((opt, idx) => {
                        if (!oncePerEl(opt, "aboutPhiloHover")) return;

                        opt.addEventListener("mouseover", () => {
                            opts.forEach((o, j) => j !== idx && o.classList.add("inactive"));
                            texts[idx]?.classList.add("active");
                        });

                        opt.addEventListener("mouseout", () => {
                            opts.forEach((o) => o.classList.remove("inactive"));
                            texts[idx]?.classList.remove("active");
                        });
                    });
                }

                /* Second header sticky after half viewport */
                const secondHeader = _sel(".second-header");
                if (secondHeader && oncePerEl(secondHeader, "secondHeaderSticky")) {
                    const update = () => {
                        if (window.pageYOffset > document.documentElement.clientHeight / 2)
                            secondHeader.classList.add("sticky-header");
                        else secondHeader.classList.remove("sticky-header");
                    };
                    update();
                    window.addEventListener("scroll", update);
                }

                /* Read more toggle for full-description (single people/services) */
                if ((_sel(".single-people") || _sel(".single-services")) && _sel(".read-more-btn")) {
                    const buttons = _selAll(".read-more-btn");
                    const wrapper = _sel(".full-description");
                    const fullText = _sel(".full-description .full-text");
                    const fullHeightPx = fullText?.clientHeight || 0;
                    let open = false;

                    buttons.forEach((btn) => {
                        if (!oncePerEl(btn, "readMoreBound")) return;

                        btn.addEventListener("click", () => {
                            open = !open;
                            if (!wrapper) return;

                            if (open) {
                                wrapper.classList.add("active");
                                wrapper.style.height = `${fullHeightPx / (document.documentElement.clientWidth / 100)}vw`;
                            } else {
                                wrapper.style.height = "0";
                                wrapper.classList.remove("active");
                            }
                        });
                    });
                }

                /* w-img-inner: make contact links open in new tab + copy href */
                if (_sel(".w-img-inner")) {
                    _selAll(".single-contact a").forEach((a) => a.setAttribute("target", "_blank"));
                    _selAll(".w-img-inner").forEach((imgInner) => {
                        const href =
                            imgInner.parentElement?.parentElement?.querySelector("p a")?.getAttribute("href") || "";
                        if (href) imgInner.parentElement?.setAttribute("href", href);
                    });
                }

                /* Insights archive: dynamic H1 title generation + sync active title */
                if (_sel(".page-template-page-insights")) {
                    const titleWrap = _sel(".page-template-page-insights .top-block .title");
                    const labels = _selAll(".sf-field-taxonomy-insight_category > ul > li > label");

                    if (titleWrap && oncePerEl(titleWrap, "insightsTitlesBuilt")) {
                        labels.forEach((label) => {
                            const txt = label.textContent || "";
                            if (txt.toLowerCase().includes("all")) return;
                            const h1 = document.createElement("h1");
                            h1.textContent = txt;
                            h1.classList.add(txt.toLowerCase());
                            titleWrap.appendChild(h1);
                        });
                    }

                    const syncActiveTitle = () => {
                        const titles = _selAll(".page-template-page-insights .top-block .title h1");
                        const select = _sel(".sf-field-taxonomy-insight_category .sf-input-select");
                        let matched = false;

                        titles.forEach((h1) => {
                            if (
                                select &&
                                select.value.trim().toLowerCase() === (h1.textContent || "").trim().toLowerCase()
                            ) {
                                titles.forEach((x) => x.classList.remove("active"));
                                h1.classList.add("active");
                                matched = true;
                            }
                        });

                        if (!matched && titles[0]) {
                            titles.forEach((x) => x.classList.remove("active"));
                            titles[0].classList.add("active");
                        }
                    };

                    // If a list item is active, match by index
                    const titles = _selAll(".page-template-page-insights .top-block .title h1");
                    labels.forEach((label, idx) => {
                        if (label.parentElement?.classList.contains("sf-option-active")) {
                            titles.forEach((t) => t.classList.remove("active"));
                            titles[idx]?.classList.add("active");
                        }
                    });

                    syncActiveTitle();
                    withJQ(($) => $(document).ajaxComplete(syncActiveTitle));
                }

                /* Single insights: format dates */
                if (_sel(".single-insights")) {
                    _selAll(
                        ".single-action .single-action-inner .action-date span, .top-text-block .top-date span"
                    ).forEach((span) => {
                        const dt = new Date(span.textContent);
                        span.textContent = new Intl.DateTimeFormat(locale, {
                            day: "numeric",
                            month: "long",
                            year: "numeric",
                        }).format(dt);
                    });
                }

                /* Search form: toggle label/input active on icon click */
                if (_sel(".is-search-form")) {
                    const labels = _selAll(".is-search-form > label");
                    const inputs = _selAll(".is-search-form > label > input");
                    _selAll(".is-search-icon").forEach((icon, idx) => {
                        if (!oncePerEl(icon, "searchIconToggle")) return;
                        icon.addEventListener("click", () => {
                            labels[idx]?.classList.toggle("active");
                            inputs[idx]?.classList.toggle("active");
                        });
                    });
                }

                /* Translation warning + mobile language switcher toggles */
                const warn = _sel(".warn");
                const translatedMarker = _sel(".is-translated");
                const htmlLang = html.getAttribute("lang") || "";

                const okTranslation =
                    html.hasAttribute("translated") ||
                    htmlLang.includes("en") ||
                    translatedMarker?.getAttribute("data-translated") === "translated";

                if (!okTranslation) warn?.classList.add("active");
                if (translatedMarker?.dataset?.translated?.includes("not")) warn?.classList.add("active");

                const subMenus = _selAll(".mobile-lang-switcher .wpml-ls-sub-menu");
                const firstItems = _selAll(
                    ".mobile-lang-switcher .wpml-ls-statics-shortcode_actions ul > .wpml-ls-first-item"
                );
                const topLinks = _selAll(
                    ".mobile-lang-switcher .wpml-ls-statics-shortcode_actions > ul > li > a"
                );

                firstItems.forEach((item, idx) => {
                    if (!oncePerEl(item, "mobileLangToggle")) return;
                    item.addEventListener("click", () => {
                        subMenus[idx]?.classList.toggle("active");
                        topLinks[idx]?.classList.toggle("active");
                    });
                });
            }, 0);

            /* Outside the setTimeout in the build: */

            // Privacy policy: wrap tables
            if (_sel(".privacy-policy")) {
                _selAll(".main-policies .main-text table").forEach((table) => {
                    if (!oncePerEl(table, "privacyTableWrapped")) return;
                    const point = document.createElement("div");
                    point.classList.add("point");
                    const wrapper = document.createElement("div");
                    wrapper.classList.add("new-point");
                    table.insertAdjacentElement("beforebegin", point);
                    wrapper.appendChild(table);
                    point.insertAdjacentElement("afterend", wrapper);
                });
            }

            // Single service -> store filter category for experience page
            if (_sel(".single-service")) {
                const link = _sel(".single-service .bottom-content h2 a");
                const bottom = _sel(".single-service .bottom-content");
                if (link && oncePerEl(link, "storeFilterCategory")) {
                    link.addEventListener("click", () => {
                        const cat = bottom?.dataset?.cat;
                        if (cat) localStorage.setItem("filter-category", cat);
                    });
                }
            }

            // Experience page: apply stored filter category
            if (_sel(".page-experience")) {
                const stored = localStorage.getItem("filter-category");
                if (stored) {
                    const options = _selAll(".sf-field-taxonomy-experience_practice_area select option");
                    options.forEach((opt) => {
                        if (!String(opt.value || "").includes(stored)) return;

                        withJQ(($) => {
                            if (!$.fn.select2) return;
                            const $select = $(".sf-field-taxonomy-experience_practice_area select");
                            $select.select2({ width: 300 });
                            $select.val(opt.value).trigger("change");
                            localStorage.removeItem("filter-category");
                        });
                    });
                }
            }

            // Career (jurex): upload handler heading localization
            if (_sel(".page-career-jurex")) {
                const h3 = _sel(".codedropz-upload-handler .codedropz-upload-inner h3");
                const lang = document.documentElement.getAttribute("lang") || "";
                if (h3) {
                    if (lang.includes("et")) h3.textContent = "Pukseerige failid siia";
                    else if (lang.includes("lv")) h3.textContent = "Velciet un nometiet failus šeit";
                    else if (lang.includes("lt")) h3.textContent = "Nuvilkite failus čia";
                    else h3.textContent = "Drag & Drop Files Here";
                }
            }

            // Landing page form: handle CF7 submission for subscription UI
            if (_sel(".page-template-page-landing")) {
                const form = _sel(".page-template-page-landing .modal-inner.inlanding form.wpcf7-form");
                const html = document.documentElement;
                const body = document.body;

                if (form) {
                    // Listen for successful form submission
                    form.addEventListener("wpcf7mailsent", () => {
                        localStorage.setItem("subscribed", "true");
                        html.classList.add("subscribed");
                        html.classList.remove("overflow-toggle");
                        body.classList.add("subscribed");

                        // Smooth scroll to landing section after a brief delay
                        // This allows CF7 to complete its UI updates before scrolling
                        setTimeout(() => {
                            const landingSection = document.getElementById("landing");
                            if (landingSection) {
                                // Use scrollIntoView for better browser compatibility
                                landingSection.scrollIntoView({ behavior: "smooth", block: "start" });

                                // Fallback: if scrollIntoView doesn't work, use window.scrollTo
                                // with the element's position
                                const targetPosition = landingSection.getBoundingClientRect().top + window.pageYOffset - 100;
                                window.scrollTo({
                                    top: targetPosition,
                                    behavior: "smooth"
                                });
                            }
                        }, 300); // 300ms delay allows CF7 modal to close
                    });
                }

                // Check if already subscribed on page load
                if (localStorage.getItem("subscribed")) {
                    body.classList.add("subscribed");
                    html.classList.remove("overflow-toggle");
                    html.classList.add("subscribed");
                }

                // Set Lithuania as default for landing page
                const lithuaniaBtn = _sel(".header-langs-diff .lithuania");
                if (lithuaniaBtn) {
                    lithuaniaBtn.click();
                }
            }

            // Default current-color init (build behavior)
            if (!localStorage.getItem("current-color")) {
                localStorage.setItem("current-color", "all");

                const offices = _selAll(".header-langs-diff .single-office");
                offices[0]?.click();

                const seg = window.location.href.split("/")[3] || "";
                if (seg.includes("et")) offices[1]?.click();
                else if (seg.includes("lv")) offices[2]?.click();
                else if (seg.includes("lt")) offices[3]?.click();
            }

            // Single insights: rewrite image host to triniti.eu (build behavior)
            if (_sel(".single-insights")) {
                _selAll(".content-text .top-text-block .text p img").forEach((img) => {
                    const parts = String(img.src || "").split("/");
                    if (parts.length >= 3) {
                        parts[2] = "triniti.eu";
                        img.src = parts.join("/");
                    }
                });
            }

            // Ensure og:description exists on key templates
            const needsOg =
                _sel(".single-experience") ||
                _sel(".single-insights") ||
                _sel(".single-services") ||
                _sel(".single-people");

            if (needsOg) {
                const metas = _selAll("head meta");
                const hasOgDesc = metas.some((m) =>
                    String(m.getAttribute("property") || "").includes("description")
                );

                if (!hasOgDesc) {
                    const meta = document.createElement("meta");
                    let text = "";

                    if (_sel(".single-insights")) text = _sel(".top-text-block .text p")?.textContent || "";
                    if (_sel(".single-experience")) text = _sel(".right-side-description p")?.textContent || "";
                    if (_sel(".single-people")) text = _sel(".person-info .text p")?.textContent || "";
                    if (_sel(".single-service")) text = _sel(".top-block .text p")?.textContent || "";

                    text = (text.split(".")[0] || "").trim();
                    meta.setAttribute("property", "og:description");
                    meta.setAttribute("content", text ? `${text}.` : "");
                    document.head.appendChild(meta);
                }
            }
        });
    }

    /* ------------------------------------------------------------------------ */
    /* Hook it up                                                               */
    /* ------------------------------------------------------------------------ */

    // Your file already uses jQuery(document).ready in places — this matches build.
    withJQ(($) => $(document).ready(initDomReadyFromBuild));

    // Build logic also runs on load (for carousels/sidebar/warnings/etc.)
    window.addEventListener("load", initOnLoadFromBuild);
})();

